var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuSecondary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: ".6em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 6 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm0 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm-3 8a3 3 0 1 0 6 0 3 3 0 0 0-6 0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSecondary);
export default __webpack_public_path__ + "static/media/menu_secondary.0ea6b2fd9b77ce1ee447069af2f76e4c.svg";
export { ForwardRef as ReactComponent };